module.exports = __webpack_public_path__ + "media/flags/sv-d2689d9d.svg";